export default {
  SET_WALLETS: 'wallets/SET_WALLETS',
  UPDATE_WALLET_BALANCE: 'wallets/UPDATE_WALLET_BALANCE',
};
